import CategoriesFields from './CategoriesFields';

export default CategoriesFields;
